module.exports = __webpack_public_path__ + "./fonts/RobotoMono-Bold.ttf";